/**
 * Created by senani on 12/19/18.
 */

import React, {Component} from "react";
import "./CartHeader.css";
import {FormattedMessage} from "react-intl";

class CartHeader extends Component {

    render() {
        let allChecked = this.props.allChecked;
        return (
            <div>
                <div className="container-fluid">
                    <div className="row cart-header-row">
                        <div className="col-md-1 no-padding">
                            <input type="checkbox" checked={allChecked}
                                   onChange={this.props.toggleAllItems}/>&nbsp;
                            <label>
                                <FormattedMessage id="app.cart.header.all"
                                                  defaultMessage="All"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-6 no-padding">
                            <label>
                                <FormattedMessage id="app.cart.header.item"
                                                  defaultMessage="Item"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-2 price-header">
                            <label className="right-align">
                                <FormattedMessage id="app.cart.header.price"
                                                  defaultMessage="Price"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-3 pull-right action-header">
                            <label><FormattedMessage id="app.cart.header.actions"
                                                     defaultMessage="Actions"
                                                     description=""/>
                            </label>
                        </div>
                    </div>
                </div>
                <hr id="header-separator"/>
            </div>
        )
    }
}

export default CartHeader;



// WEBPACK FOOTER //
// ./src/components/Site/Cart/CartHeader/CartHeader.js